import { CostRow, decimalDollars, TruckingUnit } from "./calculator";
export type LibraryItem = {
  defaultTonnage?: number;
  defaultRateHourly?: number;
  defaultRateTon?: number;
  id: string;
  name: string;
  rate?: number;
  cost?: number;
  feeAmount?: number;
  chargeType?: string;
};
export function libraryCostRow(
  category: "labor" | "equipment" | "other" | "trucking",
  item: LibraryItem,
  unit: TruckingUnit = "Hours",
  enteredRate = ""
): CostRow {
  if (category === "trucking") {
    const hourly = decimalDollars(String(item.defaultRateHourly ?? 0));
    const tons = decimalDollars(String(item.defaultRateTon ?? 0));
    return {
      name: item.name,
      sourceName: item.name,
      sourceId: item.id,
      sourceType: "transfer_truck",
      category,
      truckingUnit: unit,
      unit,
      trucksNeeded: unit === "Hours" ? "1" : null,
      truckCountDefault: unit === "Hours",
      quantity: "1",
      calculation: "manual",
      truckCapacity: String(item.defaultTonnage ?? 0),
      truckRateHours: hourly,
      truckRateTons: tons,
      rate: unit === "Hours" ? hourly : unit === "Tons" ? tons : enteredRate,
    };
  }
  const units: Record<string, string> = {
    HOURLY: "Hours",
    MILEAGE: "Mileage",
    FULL_DAY: "Days",
    HALF_DAY: "Half Day",
  };
  return {
    sourceType:
      category === "labor" ? "crew" : category === "equipment" ? "equipment" : "additional_cost",
    sourceId: item.id,
    sourceName: item.name,
    name: item.name,
    category,
    quantity: category === "other" ? String(item.feeAmount ?? 1) : "1",
    unit:
      category === "labor"
        ? "Hours"
        : category === "other"
        ? "Each"
        : units[item.chargeType ?? ""] ?? "Each",
    rate: decimalDollars(String(category === "other" ? item.cost ?? 0 : item.rate ?? 0)),
    calculation: "manual",
  };
}

export function plantMaterialRow(
  plant: { id: string; name: string },
  product: { id: string; type: string; rate: number },
  unit: string
): CostRow {
  return {
    name: product.type,
    sourceName: product.type,
    sourceType: "plant_product",
    sourceId: product.id,
    sourcePlantId: plant.id,
    sourcePlantName: plant.name,
    category: "material",
    quantity: "1",
    unit,
    rate: decimalDollars(String(product.rate)),
    calculation: "manual",
  };
}
